import { enqueueSnackbar } from "notistack";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CONTENT_STATUS_COMPLETED_ID, SAVE_ACCESSLOG_EDUCATION_COMPLETED } from "../../utility/constants/common-constants";
import ArticleReaderCard from "./ArticleReaderCard";
import { useSaveContentStatusMutation } from "./services/SaveContentStatusAPISlice";
import VideoReaderCard from "./VideoReaderCard";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { resetLearningContent } from "./services/LearningContentDataSlice";
import BackgroundLayout from "../../components/custom-backgrounds/BackgroundLayout";
import { useSaveContentClickMutation } from "./services/SaveContentStatusAccessLogAPISlice";

const ViewLearningContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    type,
    category,
    isNew,
    videoUrl,
    fullHtml,
    title,
    summarry,
    casePlanMilestoneMappingId,
    activityCompletionStatus,
    publisherName,
    publishedDate,
    activityPoints,
    audioUrl,
    thumbnail,
    length,
    lang,
    patientProfileId,
    educationalContentIdentifier,
    educationalContentSourceId
  } = useAppSelector((state) => state.learningContent);
  const pendingStatuses = [
    t("inProgress"),
    t("pending"),
    t("taskPending"),
    t("notCompleted"),
    t("initiated"),
    t("notStarted"),
  ];

  const isCompleteBtnVisible = pendingStatuses.includes(
    activityCompletionStatus ? activityCompletionStatus : ""
  );

  const hideCheck = !activityCompletionStatus;

  const patientUserName = useAppSelector(
    (state) => state.patientProfileDetails.patientProfileInfo.userName
  );
  const arrivedFrom = useAppSelector(
    (state) => state.learningContent.navigationInfo?.arrivedFrom
  );

  const [contentStatus] = useSaveContentStatusMutation();
  const [saveContentClick] = useSaveContentClickMutation();

  const handleComplete = async () => {
    try {
      const body = {
        casePlanMilestoneMappingId: casePlanMilestoneMappingId,
        statusId: CONTENT_STATUS_COMPLETED_ID,
        updatedBy: patientUserName || "Patient",
      };

      await contentStatus({ body }).unwrap();

      const accessLogBody = {
        casePlanMilestoneMappingId: casePlanMilestoneMappingId || "",
        patientProfileId: patientProfileId,
        planId: 1,
        caseId: 1,
        milestoneId: 1,
        contentIdentifier: educationalContentIdentifier,
        contentWatchedDurationInMins: 1,
        action: SAVE_ACCESSLOG_EDUCATION_COMPLETED,
        educationalContentSourceId: educationalContentSourceId,
      };

      await saveContentClick({
        body: accessLogBody,
        patientPreferredLang: lang,
      }).unwrap();

      handleBack();

      enqueueSnackbar(t("viewLearningContent.successStausMilestone"), {
        variant: "success",
      });
    } catch (err: any) {
      enqueueSnackbar(t("anErrorOccurred"), { variant: "error" });
    }
  };

  const handleBack = () => {
    dispatch(resetLearningContent());

    if (arrivedFrom) {
      navigate(arrivedFrom);
    } else {
      navigate(-1);
    }
  };

  const bgProps = {
    variant: "default" as const,
    height: { xs: "600px", sm: "640px", md: "500px" },
    showFooter: true,
  };

  if (type === "videos") {
    return (
      <BackgroundLayout {...bgProps}>
        <VideoReaderCard
          category={category}
          isNew={isNew}
          activityPoints={activityPoints}
          title={title}
          videoUrl={videoUrl}
          isCompleteBtnVisible={isCompleteBtnVisible}
          thumbnail={thumbnail}
          summarry={summarry}
          onComplete={handleComplete}
          navigateBack={handleBack}
          length={length}
          publishedDate={publishedDate}
          publisherName={publisherName}
          hideCheckMark={hideCheck}
        />
      </BackgroundLayout>
    );
  }

  if (type === "articles") {
    return (
      <BackgroundLayout {...bgProps}>
        <ArticleReaderCard
          category={category}
          isNew={isNew}
          fullHtml={fullHtml}
          title={title}
          isCompleteBtnVisible={isCompleteBtnVisible}
          activityPoints={activityPoints}
          audioUrl={audioUrl}
          thumbnail={thumbnail}
          onComplete={handleComplete}
          navigateBack={handleBack}
          publishedDate={publishedDate}
          publisherName={publisherName}
          hideCheckMark={hideCheck}
        />
      </BackgroundLayout>
    );
  }

  return null;
};

export default ViewLearningContent;
